import { render, staticRenderFns } from "./formTheFirstTop10Shareholders.vue?vue&type=template&id=7df46334&scoped=true"
import script from "./formTheFirstTop10Shareholders.vue?vue&type=script&lang=js"
export * from "./formTheFirstTop10Shareholders.vue?vue&type=script&lang=js"
import style0 from "./formTheFirstTop10Shareholders.vue?vue&type=style&index=0&id=7df46334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df46334",
  null
  
)

export default component.exports